import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import './App.css';

// Import page components
import HomePage from './pages/HomePage';
import StrategyGenerator from './pages/StrategyGenerator';
import SecurityAnalyzer from './pages/SecurityAnalyzer';
import LearnPage from './pages/LearnPage';

// Import components
import Navigation from './components/Navigation';

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/generate" element={<StrategyGenerator />} />
            <Route path="/analyze" element={<SecurityAnalyzer />} />
            <Route path="/learn" element={<LearnPage />} />
          </Routes>
        </AnimatePresence>
      </div>
    </Router>
  );
}

export default App;
